import "./home.css";
import havan from "./havan.png";
import satya from "./satya.png";
import balaji from "./balaji.jpg";
import temple from "./temple.jpg";
import god from "./god.jpg";
import asd from "./asd.jpg";
import sdf from "./sdf.jpg";
import dfg from "./dfg.jpg";
import zxc from "./zxc.jpg";
import xcv from "./xcv.jpg";
import murgan from "./murgan.jpg";
import chandi from "./chandi.png";
import navgraha from "./navgraha.png";
import om from "./om.png";
import swastik from "./swastik.png";
import diya from "./diya.png";
import kalash from "./kalash.png";
import trishul from "./trishul.png";
import ganesha from "./ganesha.png";
import namakaranam from "./namakaranam.png";
import anna from "./anna.png";
import ganpati from "./ganpati.png";
import marriage from "./marriage.png";
import aksharavhyasam from "./aksharavhyasam.png";
import nishchit from "./nishchit.png";
import laxmi from "./laxmi.png";
import ayudha from "./ayudha.png";
import rudra from "./rudra.png";
import one from "./1.jpg";
import two from "./2.jpg";
import three from "./3.jpg";
import four from "./4.jpg";
import five from "./5.jpg";
import six from "./6.jpg";
import seven from "./7.jpg";
import eight from "./8.jpg";
import nine from "./9.jpg";
import ten from "./10.jpg";
import punyaha from "./punyaha.png";
import z from "./z.jpg";
import v from "./v.jpg";
import w from "./w.jpg";
import x from "./x.jpg";
import y from "./y.jpg";
import { KnowMoreButton } from "./knowMoreButton";
import { Gallery } from "../gallery/gallery";

export const Home = () => {
  return (
    <>
      <div className="section-list">
        <section class="services">
          <h2>Preserving Traditions, Perfecting Rituals</h2>
          <h4>
            Authentic Telugu rituals, guided by SV Vedic University-qualified
            priests
          </h4>
          <div class="service-list">
            <div class="service">
              <img className="serviceImg" src={balaji} alt="Balaji" />
            </div>
            <div class="service">
              <img className="serviceImg" src={temple} alt="Temple" />
            </div>
            <div class="service">
              <img className="serviceImg" src={god} alt="God" />
            </div>
          </div>
          <KnowMoreButton />
        </section>
        <section class="services">
          <h2>Your Trusted Partner for Sacred Celebrations</h2>
          <h4>
            Seamlessly organized pujas with in-house priests and complete
            material support
          </h4>
          <div class="service-list">
            <div class="service">
              <img className="serviceImg" src={asd} alt="Om" />
            </div>
            <div class="service">
              <img className="serviceImg" src={sdf} alt="Temple" />
            </div>
            <div class="service">
              <img className="serviceImg" src={dfg} alt="God" />
            </div>
          </div>

          <KnowMoreButton />
        </section>
        <section class="services">
          <h2>Preserving Traditions, Perfecting Rituals</h2>
          <h4>
            Authentic Telugu rituals, guided by SV Vedic University-qualified
            priests
          </h4>
          <div class="service-list">
            <div class="service">
              <img className="serviceImg" src={zxc} alt="Temple" />
            </div>
            <div class="service">
              <img className="serviceImg" src={murgan} alt="Murgan" />
            </div>
            <div class="service">
              <img className="serviceImg" src={xcv} alt="God" />
            </div>
          </div>
          <KnowMoreButton />
        </section>
      </div>

      <div>
        <section class="services pooja-blocks">
          <h2>15+ Years of Tradition | 100+ Qualified Priests</h2>
          <h4>Rooted in Tradition, Delivered with Excellence</h4>
          <div class="pooja-container">
            <div class="pooja-item">
              <img src={om} alt="Sathya Narayana Pooja" />
              <p>SVV university Qualified Priests</p>
            </div>
            <div class="pooja-item">
              <img src={swastik} alt="Lakshmi Pooja" />
              <p>Tailored for Telugu Families</p>
            </div>
            <div class="pooja-item">
              <img src={ganesha} alt="Durga Pooja" />
              <p>Multilingual priests</p>
            </div>
            <div class="pooja-item">
              <img src={kalash} alt="Saraswati Pooja" />
              <p>Process-Oriented Approach</p>
            </div>
            <div class="pooja-item">
              <img src={trishul} alt="Krishna Pooja" />
              <p>Focus on Knowledge</p>
            </div>
            <div class="pooja-item">
              <img src={diya} alt="Navagraha Pooja" />
              <p>Complete Material Support</p>
            </div>
          </div>

          <KnowMoreButton href="about" />
        </section>
      </div>

      <div>
        <section class="services responsive-list">
          <h2>Our Rituals, Your Sacred Journey</h2>
          <h4>Guiding you through every step with devotion and precision.</h4>
          <ul class="checklist">
            <li>
              <span class="check-icon">🔥</span> Initial Inquiry & Understanding
              Requirements
            </li>
            <li>
              <span class="check-icon">🌺</span> Custom Ritual Planning
            </li>
            <li>
              <span class="check-icon">🕉️</span> Pujari Assignment
            </li>
            <li>
              <span class="check-icon">📿</span> Material Preparation
            </li>
            <li>
              <span class="check-icon">🔱</span> Pre-Ritual Guidance
            </li>
            <li>
              <span class="check-icon">🙏</span> Ritual Execution
            </li>
            <li>
              <span class="check-icon">📜</span> Post-Ritual Support
            </li>
          </ul>
          <KnowMoreButton text="Contact Us" href="contact" />
        </section>
      </div>

      <div>
        <section class="services pooja-blocks">
          <h2>Pathways to the Sacred: Our Signature Services</h2>
          <h4>Guiding Your Spiritual Journey with Expertise and Devotion</h4>
          <h3> Ceremonies</h3>
          <div class="pooja-container">
            <div class="pooja-item">
              <img src={havan} alt="Gruhapravesam" />
              <p>Gruhapravesam</p>
            </div>
            <div class="pooja-item">
              <img src={marriage} alt="Marriage" />
              <p>Marriage</p>
            </div>
            <div class="pooja-item">
              <img src={namakaranam} alt="Namakaranam" />
              <p>Namakaranam</p>
            </div>
            <div class="pooja-item">
              <img src={aksharavhyasam} alt="Aksharabhyasam" />
              <p>Aksharabhyasam</p>
            </div>
            <div class="pooja-item">
              <img src={anna} alt="Anna prashana" />
              <p>Anna prashana</p>
            </div>
            <div class="pooja-item">
              <img src={nishchit} alt="Nischitartham" />
              <p>Nischitartham</p>
            </div>
          </div>
          <KnowMoreButton href="details" />
        </section>
      </div>

      <div>
        <section class="services pooja-blocks">
          <h2>Divine Journeys: Exclusive Spiritual Offerings</h2>
          <h4>Navigating Your Spiritual Path with Wisdom and Dedication</h4>
          <h3>Pujas</h3>
          <div class="pooja-container">
            <div class="pooja-item">
              <img src={ganpati} alt="Ganapati Puja" />
              <p>Ganapati Puja</p>
            </div>
            <div class="pooja-item">
              <img src={laxmi} alt="Lakshmi Puja" />
              <p>Lakshmi Puja</p>
            </div>
            <div class="pooja-item">
              <img src={ayudha} alt="Ayudha Puja" />
              <p>Ayudha Puja</p>
            </div>
            <div class="pooja-item">
              <img src={rudra} alt="Rudra Puja" />
              <p>Rudra Puja</p>
            </div>
            <div class="pooja-item">
              <img src={satya} alt="Satya Narayana Puja" />
              <p>Satya Narayana Puja</p>
            </div>
            <div class="pooja-item">
              <img src={punyaha} alt="Punyaha Vachanam" />
              <p>Punyaha Vachanam</p>
            </div>
          </div>
          <KnowMoreButton href="details" />
        </section>
      </div>

      <div>
        <section class="services">
          <h2>Holy Journeys: Distinctive Divine Encounters</h2>
          <h4>Leading Your Spiritual Path with Knowledge and Devotion</h4>
          <h3>Homas</h3>
          <div class="homa-container">
            <div class="homa-item">
              <img src={four} alt="Ganapathi Homa" />
              <p>Ganapathi Homa</p>
            </div>
            <div class="homa-item">
              <img src={five} alt="Laxmi Homa" />
              <p>Laxmi Homa</p>
            </div>
            <div class="homa-item">
              <img src={three} alt="Chandi Homa" />
              <p>Chandi Homa</p>
            </div>
            <div class="homa-item">
              <img src={one} alt="Pratyangira Homa" />
              <p>Pratyangira Homa</p>
            </div>
            <div class="homa-item">
              <img src={two} alt="Lakshmi Ganapati Homa" />
              <p>Lakshmi Ganapati Homa</p>
            </div>
            <div class="homa-item">
              <img src={eight} alt="Ayushya Homa" />
              <p>Ayushya Homa</p>
            </div>
            <div class="homa-item">
              <img src={seven} alt="Vastu Shanti Homa" />
              <p>Vastu Shanti Homa</p>
            </div>
            <div class="homa-item">
              <img src={six} alt="Mrutyunjaya Homa" />
              <p>Mrutyunjaya Homa</p>
            </div>
            <div class="homa-item">
              <img src={nine} alt="Dhanvantari Homa" />
              <p>Dhanvantari Homa</p>
            </div>
            <div class="homa-item">
              <img src={ten} alt="Sudarshana Homa" />
              <p>Sudarshana Homa</p>
            </div>
          </div>
          <KnowMoreButton href="details" />
        </section>
      </div>
      <div>
        <section class="services">
          <h2>Sacred Pathways: Unique Spiritual Experiences</h2>
          <h4>Guiding Your Sacred Journey with Insight and Commitment</h4>
          <h3>Santis</h3>
          <div class="shanti-container">
            <div class="shanti-item">
              <img src={v} alt="Shashtti Poorthi" />
              <p>Shashtti Poorthi</p>
            </div>
            <div class="shanti-item">
              <img src={w} alt="Navagraha Shanti" />
              <p>Navagraha Shanti</p>
            </div>
            <div class="shanti-item">
              <img src={x} alt="Bheema Ratha Shanthi" />
              <p>Bheema Ratha Shanthi</p>
            </div>
            <div class="shanti-item">
              <img src={y} alt="Sahasra Chandra Darshana Santhi" />
              <p>Sahasra Chandra Darshana Santhi</p>
            </div>
            <div class="shanti-item">
              <img src={z} alt="Nakshatra Shanti" />
              <p>Nakshatra Shanti</p>
            </div>
          </div>
          <KnowMoreButton href="details" />
        </section>
      </div>

      <div>
        <section class="services">
          <h2>Voices of Gratitude: Our Customers Speak</h2>
          <p>
            Here are some words from our satisfied devotees who have experienced
            our divine services.
          </p>
          <div class="testimonials-container">
            <div class="testimonial-item">
              <p>
                <b>"A Seamless Ritual Experience": </b>
                "From arranging materials to guiding every step of the
                Satyanarayana Puja, the team was incredible. Their attention to
                detail brought peace and blessings to our home."
              </p>
              <h4>- Ramesh Sharma</h4>
            </div>
            <div class="testimonial-item">
              <p>
                <b>"Tradition Perfectly Preserved": </b>
                "Vaidika Vignanam Samvardhini helped us revive a long-forgotten
                family ritual. The priests explained everything beautifully,
                making it meaningful for all generations."
              </p>
              <h4>- Meera Iyer</h4>
            </div>
            <div class="testimonial-item">
              <p>
                <b>"Expert Guidance, Flawless Execution": </b>
                "Their knowledge and process-oriented approach stood out. The
                priests ensured our wedding ceremony was not just perfect but
                spiritually enriching."
              </p>
              <h4>- Anil Verma</h4>
            </div>
            <div class="testimonial-item">
              <p>
                <b>"Beyond Expectations!": </b>
                "Booking through their platform was effortless, and their
                in-house priests were professional and knowledgeable. They made
                our housewarming ceremony stress-free and special."
              </p>
              <h4>- Venky Raman</h4>
            </div>
          </div>
          <KnowMoreButton text="Contact Us" href="contact" />
        </section>
      </div>

      <div>
        <section class="services faq-section">
          <h2>Where Tradition Meets Devotion</h2>
          <p>
            Vaidika Vignanam Samvardhini established in 2010, has been a beacon
            of authenticity and tradition in the world of Telugu rituals.
            Specializing in tailored pujas, our in-house priests, certified by
            SV Vedic University, ensure every ritual is executed with precision,
            care, and deep reverence. With a commitment to process-driven
            services and a strong focus on customer education, we provide a
            seamless experience for Telugu-speaking families across India,
            preserving their sacred traditions with the utmost devotion.
          </p>
          <h3>Answers to Your Sacred Queries</h3>
          <ul class="faq-list">
            <li>
              <strong>
                1. How do I book a puja with Vaidika Vignanam Samvardhini?
              </strong>
              <br />
              Booking is easy through our website or by contacting us directly.
              Simply fill in the form with your puja details, and our team will
              guide you through the process.
            </li>
            <li>
              <strong>2. Are the priests qualified?</strong>
              <br />
              Yes, all our priests are certified by the prestigious S.V Vedic
              University, T.T.D Tirupati, ensuring that your rituals are
              performed with the highest level of authenticity and expertise.
            </li>
            <li>
              <strong>3. Can I choose the puja materials?</strong>
              <br />
              Yes, we provide all the necessary materials for your puja. If you
              have specific preferences, let us know, and we’ll customize
              everything to your needs.
            </li>
            <li>
              <strong>4. How long does a typical puja take?</strong>
              <br />
              The duration of each puja varies depending on the type of ritual.
              Our team will provide you with a detailed explanation of the
              timings when you book, ensuring a smooth experience.
            </li>
            <li>
              <strong>5. Is there a language barrier with the priests?</strong>
              <br />
              Our priests are fluent in Telugu, making it easier for you to
              connect and understand the significance of each step during the
              puja. We also offer explanations in other languages if needed.
            </li>
          </ul>
          <KnowMoreButton href="about" />
        </section>
        <Gallery />
      </div>
    </>
  );
};
